import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Body from './Body'
import syneronMuiTheme from './syneronMuiTheme'


const muiTheme = syneronMuiTheme(navigator.userAgent)

class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <Body />
      </MuiThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js